// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../DisplayNameDeclaration";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "../TagDeclaration";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        titleDeclarations: [],
        superordinateCategoryNameDeclarations: [],
        subTextDeclarations: [],
        descriptionDeclarations: [],
        imageSetId: "0",
        tagDeclarations: [],
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    result.titleDeclarations = value.titleDeclarations.map(value => encodeJson_1(value));
    result.superordinateCategoryNameDeclarations = value.superordinateCategoryNameDeclarations.map(value => encodeJson_1(value));
    result.subTextDeclarations = value.subTextDeclarations.map(value => encodeJson_1(value));
    result.descriptionDeclarations = value.descriptionDeclarations.map(value => encodeJson_1(value));
    if (value.imageSetId !== undefined)
        result.imageSetId = tsValueToJsonValueFns.int64(value.imageSetId);
    result.tagDeclarations = value.tagDeclarations.map(value => encodeJson_2(value));
    return result;
}
export function decodeJson(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const result = getDefaultValue();
    result.titleDeclarations = (_b = (_a = value.titleDeclarations) === null || _a === void 0 ? void 0 : _a.map((value) => decodeJson_1(value))) !== null && _b !== void 0 ? _b : [];
    result.superordinateCategoryNameDeclarations = (_d = (_c = value.superordinateCategoryNameDeclarations) === null || _c === void 0 ? void 0 : _c.map((value) => decodeJson_1(value))) !== null && _d !== void 0 ? _d : [];
    result.subTextDeclarations = (_f = (_e = value.subTextDeclarations) === null || _e === void 0 ? void 0 : _e.map((value) => decodeJson_1(value))) !== null && _f !== void 0 ? _f : [];
    result.descriptionDeclarations = (_h = (_g = value.descriptionDeclarations) === null || _g === void 0 ? void 0 : _g.map((value) => decodeJson_1(value))) !== null && _h !== void 0 ? _h : [];
    if (value.imageSetId !== undefined)
        result.imageSetId = jsonValueToTsValueFns.int64(value.imageSetId);
    result.tagDeclarations = (_k = (_j = value.tagDeclarations) === null || _j === void 0 ? void 0 : _j.map((value) => decodeJson_2(value))) !== null && _k !== void 0 ? _k : [];
    return result;
}
export function encodeBinary(value) {
    const result = [];
    for (const tsValue of value.titleDeclarations) {
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    for (const tsValue of value.superordinateCategoryNameDeclarations) {
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    for (const tsValue of value.subTextDeclarations) {
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    for (const tsValue of value.descriptionDeclarations) {
        result.push([4, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.imageSetId !== undefined) {
        const tsValue = value.imageSetId;
        result.push([5, tsValueToWireValueFns.int64(tsValue)]);
    }
    for (const tsValue of value.tagDeclarations) {
        result.push([6, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 1).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.titleDeclarations = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 2).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.superordinateCategoryNameDeclarations = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 3).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.subTextDeclarations = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 4).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.descriptionDeclarations = value;
    }
    field: {
        const wireValue = wireFields.get(5);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.imageSetId = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 6).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.tagDeclarations = value;
    }
    return result;
}
